import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNavigation from './locales/en/navigation.json';
import enClients from './locales/en/clients.json';
import enWorkoutTypes from './locales/en/workoutTypes.json';
import enSchedule from './locales/en/schedule.json';
import enCalendar from './locales/en/calendar.json';
import enUsers from './locales/en/users.json';
import enSessions from './locales/en/sessions.json';
import enDashboard from './locales/en/dashboard.json';
import enGymSettings from './locales/en/gymSettings.json';
import enMedicalRecord from './locales/en/medicalRecord.json';
import enNotes from './locales/en/notes.json';

// Greek translations
import elCommon from './locales/el/common.json';
import elAuth from './locales/el/auth.json';
import elNavigation from './locales/el/navigation.json';
import elClients from './locales/el/clients.json';
import elWorkoutTypes from './locales/el/workoutTypes.json';
import elSchedule from './locales/el/schedule.json';
import elCalendar from './locales/el/calendar.json';
import elUsers from './locales/el/users.json';
import elSessions from './locales/el/sessions.json';
import elDashboard from './locales/el/dashboard.json';
import elGymSettings from './locales/el/gymSettings.json';
import elMedicalRecord from './locales/el/medicalRecord.json';
import elNotes from './locales/el/notes.json';

const resources = {
  en: {
    translation: {
      ...enCommon,
      ...enAuth,
      ...enNavigation,
      ...enClients,
      ...enWorkoutTypes,
      ...enSchedule,
      ...enCalendar,
      ...enUsers,
      ...enSessions,
      ...enDashboard,
      ...enGymSettings,
      ...enMedicalRecord,
      ...enNotes,
    },
  },
  el: {
    translation: {
      ...elCommon,
      ...elAuth,
      ...elNavigation,
      ...elClients,
      ...elWorkoutTypes,
      ...elSchedule,
      ...elCalendar,
      ...elUsers,
      ...elSessions,
      ...elDashboard,
      ...elGymSettings,
      ...elMedicalRecord,
      ...elNotes,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'el', // Greek as default
    lng: 'el', // Set Greek as the initial language
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
